import type { SnapshotPosition } from "../../lib/api";
import { CashRow } from "./CashRow";
import { PositionRow } from "./PositionRow";

export function PositionsTable({
	positions,
	cashUsdcRaw,
	totalValueUsdcRaw,
}: {
	positions: SnapshotPosition[];
	cashUsdcRaw: string | null;
	totalValueUsdcRaw: string;
}) {
	if (positions.length === 0 && cashUsdcRaw === null) {
		return (
			<p className="rounded-md border border-slate-800 bg-slate-900/40 p-3 text-xs text-slate-400">
				No priced positions and no cash for this wallet.
			</p>
		);
	}
	return (
		<div className="overflow-hidden rounded-lg border border-slate-800">
			<table className="w-full text-sm">
				<thead className="bg-slate-900/60 text-left text-xs uppercase tracking-wide text-slate-400">
					<tr>
						<th className="px-3 py-2 font-medium">Asset</th>
						<th className="px-3 py-2 text-right font-medium">Value</th>
						<th className="px-3 py-2 font-medium">Weight</th>
						<th className="px-3 py-2 text-right font-medium">APY</th>
						<th className="px-3 py-2 text-right font-medium">Exit</th>
						<th className="px-3 py-2" />
					</tr>
				</thead>
				<tbody className="divide-y divide-slate-800">
					{cashUsdcRaw !== null && (
						<CashRow
							cashUsdcRaw={cashUsdcRaw}
							totalValueUsdcRaw={totalValueUsdcRaw}
						/>
					)}
					{positions.map((p) => (
						<PositionRow key={`${p.protocol}:${p.vaultAddress}`} position={p} />
					))}
				</tbody>
			</table>
		</div>
	);
}
